import { useId } from 'react'

/**
 * The Sapling mark: a stem with two leaves, one glyph.
 *
 * `tone="ink"` draws it in currentColor so it sits in text and nav like a
 * character. `tone="brand"` fills it with the moss → leaf → growth gradient
 * for the few large, still moments (welcome, empty thread). Both read the
 * same at 16px and 160px; the paths are shared with the app icon.
 */
export function SaplingMark({
  size = 22,
  tone = 'ink',
  className,
}: {
  size?: number
  tone?: 'ink' | 'brand'
  className?: string
}) {
  const id = useId()
  const fill = tone === 'brand' ? `url(#${id})` : 'currentColor'
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      className={className}
      aria-hidden="true"
    >
      {tone === 'brand' && (
        <defs>
          <linearGradient id={id} gradientUnits="userSpaceOnUse" x1="4" y1="22" x2="20" y2="3">
            <stop offset="0%" stopColor="var(--brand-moss)" />
            <stop offset="55%" stopColor="var(--brand-leaf)" />
            <stop offset="100%" stopColor="var(--brand-growth)" />
          </linearGradient>
        </defs>
      )}
      <path d="M11.3 12.6h2.1c-.15 3-.2 5.7-.2 8.35a1.05 1.05 0 0 1-2.1 0c0-2.65.05-5.35.2-8.35z" />
      <path d="M12.3 13.9C7.9 13.9 4.8 11 4.2 6.2c4.8-.1 7.9 3 8.1 7.7z" />
      <path d="M12.2 13.7c-.2-4.8 3.1-8 8-8-.4 4.9-3.5 8.1-8 8z" />
    </svg>
  )
}
